import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { backend_util } from '@tensorflow/tfjs-core';
import { SplitV, util } from '@tensorflow/tfjs-core';
import { slice } from './Slice';
export function splitV(args) {
  var inputs = args.inputs,
      backend = args.backend,
      attrs = args.attrs;
  var x = inputs.x;
  var numOrSizeSplits = attrs.numOrSizeSplits,
      axis = attrs.axis;
  var $axis = util.parseAxisParam(axis, x.shape)[0];
  var splitSizes = backend_util.prepareSplitSize(x, numOrSizeSplits, $axis);
  var begin = new Array(x.shape.length).fill(0);
  var size = x.shape.slice();
  return splitSizes.map(function (s) {
    var sliceSize = _toConsumableArray(size);

    sliceSize[$axis] = s;
    var sliceT = slice({
      inputs: {
        x: x
      },
      backend: backend,
      attrs: {
        begin: begin,
        size: sliceSize
      }
    });
    begin[$axis] += s;
    return sliceT;
  });
}
export var splitVConfig = {
  kernelName: SplitV,
  backendName: 'cpu',
  kernelFunc: splitV
};